import React from 'react'

const CheckIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="9.6" viewBox="0 0 12 9.6"><path d="M109.3 123.063l-6.828 7.356a1.135 1.135 0 0 1-1.707 0l-2.889-3.162a1.179 1.179 0 0 1 .066-1.613 1.23 1.23 0 0 1 1.641.065l2.035 2.258 5.975-6.388a1.166 1.166 0 0 1 1.641-.064 1.1 1.1 0 0 1 .066 1.548z" transform="translate(-97.59 -121.206)" fill={props.fill} /></svg>
)

export default CheckIcon
